import React from "react";
import styled from "styled-components";
import GlobalFonts from "../../fonts/fonts";
import "../../fonts/font.css";

import Searching from "../../images/search_icon.png";
// import Money from "../../images/money.png";

import { selectTimeContext } from "../main/body_main";

import {
  StyledBox,
  GradientBox,
  PossibilityBox,
  TextWrapper,
  CardTitle,
  CardText,
  Input,
  InputDiv,
  SearchIcon,
  Radio,
  RadioLabel,
  Select,
  Caption,
  MoneyIcon,
  DashLine,
  Badge,
  Badges,
  BadgeText,
  BadgeIcon,
  SolutionWrapper,
  SolutionContentsWrapper,
} from "./card_componets";

export const CardWithInput = ({
  title,
  text,
  maxPark,
  borderColor,
  borderSize,
  boxShadow,
  ...rest
}) => (
  <StyledBox
    borderColor={borderColor}
    borderSize={borderSize}
    boxShadow={boxShadow}
  >
    <GlobalFonts />
    <CardTitle> {title}</CardTitle>
    <CardText fontSize="17" lineHight="20">
      {" "}
      {text}{" "}
    </CardText>
    <Input type="number" value={maxPark} {...rest}></Input>
  </StyledBox>
);

export const CardWithSearch = ({ title, text, search }) => (
  <StyledBox>
    <GlobalFonts />
    <CardTitle>{title}</CardTitle>
    <CardText fontSize="14" lineHight="20">
      {text}
    </CardText>
    <InputDiv>
      {search}
      <SearchIcon />
    </InputDiv>
  </StyledBox>
);

export const CardWithRadio = ({ title, text, ...rest }) => (
  <StyledBox>
    <GlobalFonts />
    <CardTitle> {title}</CardTitle>
    <CardText fontSize="14" lineHight="20">
      {text}
    </CardText>
    <div>
      <Radio type="radio" name="manage" id="1" value="self" />
      <RadioLabel for="1">제가 직접 합니다.</RadioLabel>
    </div>
    <div>
      <Radio type="radio" name="manage" id="2" value="consignment" />
      <RadioLabel for="2">위탁업체에 맡겨요.</RadioLabel>
    </div>
  </StyledBox>
);

export const CardWithSelect = ({
  title,
  text,
  selectTimeContext,
  handleSelectTime,
  handleSelectFee,
  ...rest
}) => (
  <StyledBox>
    <GlobalFonts />
    <CardTitle>{title}</CardTitle>
    <CardText fontSize="14" lineHight="20">
      {text}
    </CardText>
    <Select value1={selectTimeContext} onChange={handleSelectTime}>
      <option value1="" hidden color="#999999">
        시간
      </option>
      <option value1="11">10분</option>
      <option value1="12">60분</option>
      <option value1="13">120분</option>
    </Select>
    <Select onChange={handleSelectFee}>
      <option value="" hidden color="#999999">
        요금
      </option>
      <option value="21">1000원</option>
      <option value="22">6000원</option>
      <option value="23">10000원</option>
      <option value="24">20000원</option>
    </Select>
  </StyledBox>
);

export const GradientCard = ({ profit, nowProfit, caption, ...rest }) => (
  <GradientBox height="120" width="790">
    <GlobalFonts />
    {/* <MoneyIcon /> */}
    <CardTitle color="#ffffff" fontSize="24">
      <span style={{ marginRight: "20px" }}>
        {" "}
        Guest님의 현재 주차장 수익은?{" "}
      </span>
      {nowProfit}원 <span> 입니다. </span>
    </CardTitle>
    <TextWrapper>
      <p>
        <span> {profit}원 </span>의 수익을 낼 수 있습니다.
      </p>
    </TextWrapper>
    <Caption color="#ffffff" fontSize="16" lineHight="17" marginTop="-30">
      *오차 범위 ±{caption}
    </Caption>
  </GradientBox>
);

export const PossibilityCard = ({possibility}) => (
  <PossibilityBox
    width="350"
    height="120"
    borderColor="#5779EF"
  >
    <CardTitle color="#5779EF" fontSize="36" marginTop="10" marginBottom="20">{possibility}% <span sfontSize="15"> 가능성있음</span></CardTitle>
    <CardText color="#000000"> 기존 수익보다 {possibility}% 증가할 가능성이 있는 주차장입니다.</CardText>
  </PossibilityBox>
);

